// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"2384159e","597":"f87a4c94","801":"8b14902d","825":"11412d99","931":"c8125618"}[chunkId] + ".chunk.js";
};